import { render, staticRenderFns } from "./SalesOrderDocumentsPage.vue?vue&type=template&id=49cc8d6a&scoped=true"
import script from "./SalesOrderDocumentsPage.vue?vue&type=script&lang=js"
export * from "./SalesOrderDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc8d6a",
  null
  
)

export default component.exports